import React from "react";

const TopContent = () => {
  return (
    <div className="mt-8 ml-2 mr-5 mb-8 flex flex-col justify-center items-center p-4  ">
      <h1 className="mb-5 text-2xl font-bold text-center  font-heading tracking-wider">
        Circle Rate Calculator
      </h1>
      <p className="text-[#2d486f]  tracking-wider px-2 ">
        Our easy-to-use and completely free Circle Rate Calculator provides you
        with an instant breakdown of your property's value. Just enter a few
        simple details—like your property’s sector, type, and area—and tap
        'Calculate' to get a precise estimate. Whether you’re buying, selling,
        or just curious, our tool is here to help you make informed decisions
        with ease. Get started now and see how simple it is to find out your
        property’s circle rate!
      </p>
    </div>
  );
};

export default TopContent;
